import { render, staticRenderFns } from "./BlogCoverPreview.vue?vue&type=template&id=37d5fde9&scoped=true&"
import script from "./BlogCoverPreview.vue?vue&type=script&lang=js&"
export * from "./BlogCoverPreview.vue?vue&type=script&lang=js&"
import style0 from "./BlogCoverPreview.vue?vue&type=style&index=0&id=37d5fde9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d5fde9",
  null
  
)

export default component.exports